import React from 'react';
import { View } from 'react-native';

export default ({ C, left, width, averageColor }: { left: number; width: number; averageColor: string; C: (color: string) => string }) => {
  return (
    <View
      style={{
        position: 'absolute',
        width,
        left,
        height: 1,
        backgroundColor: C(averageColor),
        zIndex: 10,
        top: 12,
      }}
    />
  );
};
